/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * CnsLog response payload
 * @export
 * @interface CnsLogResponse
 */
export interface CnsLogResponse {
    /**
     * 
     * @type {string}
     * @memberof CnsLogResponse
     */
    luLogTableId?: string;
    /**
     * 
     * @type {string}
     * @memberof CnsLogResponse
     */
    operationType?: string;
    /**
     * 
     * @type {string}
     * @memberof CnsLogResponse
     */
    requestContent?: string;
    /**
     * 
     * @type {string}
     * @memberof CnsLogResponse
     */
    responseContent?: string;
    /**
     * 
     * @type {string}
     * @memberof CnsLogResponse
     */
    status?: string;
    /**
     * 
     * @type {Date}
     * @memberof CnsLogResponse
     */
    timestamp?: Date;
    /**
     * 
     * @type {number}
     * @memberof CnsLogResponse
     */
    financialGroupId?: number;
    /**
     * 
     * @type {string}
     * @memberof CnsLogResponse
     */
    personWithRoleCounterParty?: string;
}

/**
 * Check if a given object implements the CnsLogResponse interface.
 */
export function instanceOfCnsLogResponse(value: object): value is CnsLogResponse {
    return true;
}

export function CnsLogResponseFromJSON(json: any): CnsLogResponse {
    return CnsLogResponseFromJSONTyped(json, false);
}

export function CnsLogResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CnsLogResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'luLogTableId': json['luLogTableId'] == null ? undefined : json['luLogTableId'],
        'operationType': json['operationType'] == null ? undefined : json['operationType'],
        'requestContent': json['requestContent'] == null ? undefined : json['requestContent'],
        'responseContent': json['responseContent'] == null ? undefined : json['responseContent'],
        'status': json['status'] == null ? undefined : json['status'],
        'timestamp': json['timestamp'] == null ? undefined : (new Date(json['timestamp'])),
        'financialGroupId': json['financialGroupId'] == null ? undefined : json['financialGroupId'],
        'personWithRoleCounterParty': json['personWithRoleCounterParty'] == null ? undefined : json['personWithRoleCounterParty'],
    };
}

export function CnsLogResponseToJSON(json: any): CnsLogResponse {
    return CnsLogResponseToJSONTyped(json, false);
}

export function CnsLogResponseToJSONTyped(value?: CnsLogResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'luLogTableId': value['luLogTableId'],
        'operationType': value['operationType'],
        'requestContent': value['requestContent'],
        'responseContent': value['responseContent'],
        'status': value['status'],
        'timestamp': value['timestamp'] == null ? undefined : ((value['timestamp']).toISOString()),
        'financialGroupId': value['financialGroupId'],
        'personWithRoleCounterParty': value['personWithRoleCounterParty'],
    };
}

